import Tippy from "@tippyjs/react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { MemberTypes, Salutation } from "Interfaces/general";
import {
  capitalizeFirstLetter,
  genderFromType,
  selfSpouseGenderFromSalutation,
} from "Services/general";
import { useDeviceType } from "app/hooks";
import { addDays, format, subMonths, subYears } from "date-fns";

const previousDate = new Date();

const converNumberFormator = (d: number) => {
  return d < 10 ? "0" + d.toString() : d.toString();
};

export const eightyFiveYearsFromCurrentDate = format(addDays((subYears(new Date(), 86)), 1), 'yyyy-MM-dd')

export const sixtyFiveYearsFromCurrentDate = format(addDays((subYears(new Date(), 66)), 1), 'yyyy-MM-dd')

export const eighteenYearsFromCurrentDate = format( subYears(new Date(), 18),'yyyy-MM-dd')

export const seventyYearsFromCurrentDate = format(addDays((subYears(new Date(), 71)), 1), 'yyyy-MM-dd')

export const twoHundredYearsFromCurrentDate = format( subYears(new Date(), 200),'yyyy-MM-dd')

export const twentyFiveYearsFromCurrentDate = format(addDays((subYears(new Date(), 25)), 1), 'yyyy-MM-dd')

export const fortyOneYearsFromCurrentDate = format(subYears(new Date(), 41), 'yyyy-MM-dd')

export const ninetyOneDays = format(subMonths(new Date(), 3), 'yyyy-MM-dd')

export const DisplayFullNameOnHover = ({
  firstName,
  middleName,
  lastName,
  memberTypeDisplayText,
  age,
  gender,
  type,
  proposerSalutation,
}: {
  memberTypeDisplayText: string;
  firstName: string;
  middleName: string;
  lastName: string;
  age: string;
  type?: MemberTypes;
  proposerSalutation: Salutation;
  gender?: string;
}) => {
  let fullName = firstName + " " + middleName + " " + lastName;
  const { isDesktop } = useDeviceType();
  const displayGender =  gender
    ? capitalizeFirstLetter(gender)
    : type
    ? type === "self" || type === "spouse"
      ? capitalizeFirstLetter(
          selfSpouseGenderFromSalutation(
            type,
            proposerSalutation
          ).toLowerCase()
        )
      : capitalizeFirstLetter(genderFromType(type).toLowerCase())
    : ""
  
  return (
    <Flex gap="1" fontSize={isDesktop ? "base" : "sm"}>
      {fullName.length > 15 ? (
        <Tippy
          content={
            <div className="rounded bg-white shadow-xl border-2 p-2 text-[12px]">
              {fullName}
            </div>
          }
        >
          <Text textTransform={"capitalize"} cursor={"pointer"}>
           {capitalizeFirstLetter(memberTypeDisplayText) +'('+fullName.slice(0, 15) + "..., " +age + ", "+displayGender+')'}
          </Text>
        </Tippy>
      ) : (
        capitalizeFirstLetter(memberTypeDisplayText) +  " (" +  fullName + ", " +  age + ", " +displayGender + ")"
      )}
     
    </Flex>
  );
};
